import styled from 'styled-components';

export default styled.div`
    .extra-text {
        font-size: 0.65rem;
        white-space: break-spaces;
        margin-top: var(--spacing-8);
    }
`;
